import { Box, Dialog, IconButton, Typography } from "@mui/material";
import { getLimitePetiteCaisse } from '../../utils/dateUtils';
import moment from 'moment';
import { useMemo, useState } from "react";
import RepartionEspecesChequesRetrait from "./rep-especes-cheques-retrait";
import { CurrencyExchange } from "@mui/icons-material";
import EspecesExchange from "./especes-exchange";

export default function Step3(props) {
    const [exchanging, setExchanging] = useState(false)
    const ttEspeces = useMemo(()=>props.petiteCaisse.reduce((tt,esp)=>tt+esp.montant*esp.count,0),[props.petiteCaisse])

    const tempActive = props.pcCompte?.limite_temp && props.pcCompte?.limite_temp_expiration && new Date(props.pcCompte.limite_temp_expiration) > new Date()
    const expDateStr = tempActive ? moment.utc(props.pcCompte.limite_temp_expiration).format('DD/MM/YYYY') : ''
    const limiteLabel = tempActive ? `de limite jusqu'au ${expDateStr}` : 'de limite mensuelle'
    const depasseLabel = tempActive ? `Attention, vous dépassez la limite autorisée jusqu'au ${expDateStr}!` : 'Attention, vous dépassez la limite de petite-caisse autorisée pour ce mois!'

    return(
        <Box>
            <Typography variant="h6" align="center">Répartition de la part locale</Typography>
            <Typography variant="subtitle1" align="center" color='red'>Vous disposer de {props.local_part?.toFixed(2)}€ de part locale</Typography>
            {props.take_petite_caisse&&<>
                <Box display='flex' justifyContent='space-between' alignItems='center' marginTop={2} marginBottom={1}>
                    <Typography variant="subtitle1">Petite-caisse</Typography>
                    {props.eglise.money_switch&&<IconButton onClick={()=>setExchanging(true)}><CurrencyExchange/></IconButton>}
                </Box>
            <RepartionEspecesChequesRetrait  { ...{repespeces:props.petiteCaisse, setRepEspeces:props.setPetiteCaisse, dispoMoney: props.dispoMoney, isPetiteCaisse:true}}/>
            </>}
            
            <Typography variant="h6" fontWeight='bold' align="center" marginTop={2}>Montant total réparti: {ttEspeces.toFixed(2)}€</Typography>

            <Typography variant="subtitle1" align="center" marginTop={2} fontWeight='bold' color={props.ttPcMensuel>getLimitePetiteCaisse(props.eglise, props.pcCompte)?'red':'green'}>
                {`Montant total des versements petite-caisse (y compris ce versement): ${props.ttPcMensuel?.toFixed(2)}€ / ${getLimitePetiteCaisse(props.eglise, props.pcCompte)?.toFixed(2)}€ ${limiteLabel}`}
            </Typography>
            {(getLimitePetiteCaisse(props.eglise, props.pcCompte)&&props.ttPcMensuel>getLimitePetiteCaisse(props.eglise, props.pcCompte))&&
                <Typography variant="h5" fontWeight={'bold'} align="center" marginTop={1} color='red'>
                    {depasseLabel}
                </Typography>
            }
            <Typography variant="subtitle1" fontWeight={'bold'} align="center" marginTop={2} color={ttEspeces<props.local_part?'green': 'red'}>
                {ttEspeces<props.local_part ? `Montant restant sur la part locale: ${(props.local_part - ttEspeces).toFixed(2)}€` : 'Attention, vous avez dépassé le montant de la part locale!'}
            </Typography>
            
            <Dialog open={exchanging} maxWidth='md' fullWidth onClose={()=>{setExchanging(false); props.cancelExchange()}}>
                <Box sx={{padding:2}}>
                    <EspecesExchange {...{close:()=>setExchanging(false), setEmptyAndclose:()=>{setExchanging(false); props.cancelExchange()}, dons: props.dons, setDispoMoney: props.setDispoMoney, exchange: props.exchange, setExchange: props.setExchange}}/>
                </Box>
            </Dialog>
        </Box>
    )
}